type LoadingBlockProps = {
  message?: string;
};

type ErrorBlockProps = {
  message: string;
  onRetry?: () => void;
};

export const LoadingBlock = ({ message = "Loading..." }: LoadingBlockProps) => (
  <div className="alert alert-info mb-3" role="status">
    {message}
  </div>
);

export const ErrorBlock = ({ message, onRetry }: ErrorBlockProps) => (
  <div className="alert alert-danger d-flex align-items-center justify-content-between mb-3" role="alert">
    <span>{message}</span>
    {onRetry ? (
      <button type="button" className="btn btn-sm btn-light" onClick={onRetry}>
        Retry
      </button>
    ) : null}
  </div>
);
